export default "__VITE_ASSET__CFYYPzPG__"